import { call, fork, takeEvery } from "redux-saga/effects";

import actionTypes from "../actionTypes";
import sendRequest from "./sendRequest";
import loginRequest from "./loginRequest";

// console.debug('saga/index.js:6')

function* sagas() {
  // console.debug('saga/index.js:30')
  yield takeEvery(
    ({ type }) => type.startsWith("Effects/"),
    function* (action) {
      switch (action.type) {
        case actionTypes["Effects/GET_REQUEST"]:
          action.method = "get";
          yield fork(sendRequest, action);
          break;
        case actionTypes["Effects/POST_REQUEST"]:
          action.method = "post";
          yield fork(sendRequest, action);
          break;
        case actionTypes["Effects/LOGIN_POST_REQUEST"]:
          action.method = "post";
          yield fork(loginRequest, action);
          break;
        case actionTypes["Effects/PUT_REQUEST"]:
          action.method = "put";
          yield fork(sendRequest, action);
          break;
        case actionTypes["Effects/DELETE_REQUEST"]:
          action.method = "delete";
          yield fork(sendRequest, action);
          break;
        default:
          // NOOP
          break;
      }
    }
  );
}
// console.debug('saga/index.js:41')
export default sagas;
